import React from 'react'
import { useSelector } from 'react-redux'
import { mapsSelector } from 'features/events/eventSlice'
import FileUpload, { IMAGE_ONLY } from 'features/forms/components/FileUpload'
import { GroupedSelectField } from 'components/ReusableStyledComponents'
import { _ } from 'utils'

export const convertGroupedOptions = (maps) => {
    const options = []
    maps.forEach((map) => {
        options.push({
            name: map.name,
            isDisabled: true,
        });
        (map.mapitems || []).forEach((item) => {
            options.push(item)
        })
    })
    return options
}

const App = () => {
    const maps = useSelector(mapsSelector)

    return (
        <>
            <FileUpload
                name="image"
                label={_('show.form.app_image')}
                accept={IMAGE_ONLY}
                maxSize={25} // in Mbs
                placeholder={_('show.form.app_image.place_holder')}
                maxImageSize={{ width: 1000, height: 500 }}
                previewImagePlacement="top-end"
                lg={1/2}
            />
            <GroupedSelectField
                name="mapitemId"
                label={_('show.form.onsite_location')}
                placeholder={_('show.form.onsite_location.placeholder')}
                helperText={_('show.form.onsite_location.helper_text')}
                options={convertGroupedOptions(maps)}
                optionLabel="name"
                optionValue="id"
                lg={1 / 2}
                showInfoIcon
            />
        </>
    )
}

export default App
